export const getIncomers = (
  node: Node,
  nodes: Node[],
  edges: Edge[],
): Node[] => {
  const incomingEdges = edges.filter(({ target }) => target === node.id);
  return incomingEdges.map(({ source }) => nodes.find((n) => n.id === source)!);
};

// given a graph, find all the connected nodes
// returns array of graphs, where each graph is a set of connected nodes
export const findConnectedGraphs = ({
  nodes,
  edges,
}: {
  nodes: string[];
  edges: Edge[];
}) => {
  const connectedGraphs: string[][] = [];
  const visitedNodes = new Set<string>();

  // find all connected nodes
  const findConnectedNodes = (nodeId: string) => {
    const connectedNodes = edges
      .filter(({ source, target }) => source === nodeId || target === nodeId)
      .map(({ target, source }) => (source === nodeId ? target : source));

    connectedNodes.forEach((connectedNode) => {
      if (!visitedNodes.has(connectedNode)) {
        visitedNodes.add(connectedNode);
        connectedGraphs[connectedGraphs.length - 1].push(connectedNode);
        findConnectedNodes(connectedNode);
      }
    });
  };

  nodes.forEach((nodeId) => {
    if (!visitedNodes.has(nodeId)) {
      visitedNodes.add(nodeId);
      connectedGraphs.push([nodeId]);
      findConnectedNodes(nodeId);
    }
  });

  return connectedGraphs;
};

export type Node = {
  id: string;
};

export type Edge = { source: string; target: string };
export type XYPosition = {
  x: number;
  y: number;
};

export type GraphPositions = Record<string, XYPosition>;

export type NodeWithPosition = Node & XYPosition;
// the layout direction (T = top, R = right, B = bottom, L = left, TB = top to bottom, ...)
export type Direction = 'TB' | 'LR' | 'RL' | 'BT';

export type LayoutAlgorithmOptions = {
  direction: Direction;
  spacing: [number, number];
};

export type LayoutAlgorithm = (
  nodes: Node[],
  edges: Edge[],
  options: LayoutAlgorithmOptions,
) => GraphPositions;
